// extracted by mini-css-extract-plugin
export default {"left":"ArrowBtn_left__tCGLS","right":"ArrowBtn_right__aGkBR"};